
export const actionTypes = {
    UPDATE_ASSET_RENAME: 'overview/UPDATE_ASSET_RENAME',
    UPDATE_ASSET_RENAME_SUCCESS: 'overview/UPDATE_ASSET_RENAME_SUCCESS',
    CLOSE_DIALOGUE: 'overview/CLOSE_DIALOGUE'
};
export const reNameStatus = {
    reNameAsset: 'RENAME_SUCCESS'
};
